import { render, staticRenderFns } from "./InternalUserForm.vue?vue&type=template&id=53eed471"
import script from "./InternalUserForm.vue?vue&type=script&lang=js"
export * from "./InternalUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports